import React from 'react';
import {
  DataTableV2,
  DataTableHeadV2,
  DataTableHeadCellV2,
  DataTableRowV2,
  DataTableCellV2,
  DataTableBodyV2,
  Label,
  AccentBar,
  IconEdit,
} from '@americanexpress/dls-react';
import * as LABELCONST from '../../constants/constFileLabelsVendor';
import * as stringConstants from '../../constants/stringConstants';
import {
  isTaxFieldVisible,
  isPaymentMethodCPCOrBIP,
  isBillingCountryAndCountryFrance,
} from '../../helper/utilityMethods';
import { isCountryChinaOrJapan, isCountryJapan, isCountrySweden, isCountryPhilippenes } from '../../helper/functions';
import LocalAddressData from '../LocalAddressData';

const ReviewPage = (props) => {
  const editSupplierInfo = (page) => {
    props.setIsEditClicked(true);
    props.setPage(page);
  };

  const billingCountry = props.formData.billingCountry?.CountryName ?? '';

  //TODO: To move the updatedPaymentMethod in seprate file for reusability.
  const updatedPaymentMethod = () => {
    if (
      props.formData.otherPaymentMethod !== '' &&
      props.formData.paymentMethod === 'Other'
    ) {
      return (
        props.formData.paymentMethod + ' : ' + props.formData.otherPaymentMethod
      );
    }
    return props.formData.paymentMethod;
  };

  props.setIsEditClicked(false);
  return (
    <div className="margin-responsive fade-in">
      <div>
        <h1>{LABELCONST.REVIEW}</h1>
        <div className="new-line" />
        <span>
          Please review your information before sending it to your American
          Express Contact.
        </span>
        <div className="new-line" />
        <div className="new-line" />
      </div>
      <AccentBar />
      <div className="new-line" />
      <div>
        <Label>{LABELCONST.SUPPLIER_CONTACT_INFORMATION}</Label>
        <Label
          className="editInfo float-right"
          onClick={() => {
            editSupplierInfo(1);
          }}
        >
          Edit
          <IconEdit />
        </Label>
      </div>
      <div className="new-line" />
      <DataTableV2 id="table-base-instance" striped={true}>
        <DataTableHeadV2>
          <DataTableRowV2>
            <DataTableHeadCellV2 className="table-gap">
              Field
            </DataTableHeadCellV2>
            <DataTableHeadCellV2>Value</DataTableHeadCellV2>
          </DataTableRowV2>
        </DataTableHeadV2>
        <DataTableBodyV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.REGION}</DataTableCellV2>
            <DataTableCellV2>
              {props.formData.region.RegionName}
            </DataTableCellV2>
            {/* TODO: Add Edit functionality */}
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.BILLING_COUNTRY}</DataTableCellV2>
            <DataTableCellV2>
              {billingCountry.toLowerCase() !== 'other'
                ? billingCountry
                : `Other - ${props.formData.otherCountry}`}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.BILLING_CURRENCY}</DataTableCellV2>
            <DataTableCellV2>
              {props.formData.billingCurrency?.CurrencyCode +
                ' - ' +
                props.formData.billingCurrency.CurrencyName}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SUPPLIER_REGISTERED_NAME}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierRegisteredName}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SUPPLIER_REGISTERED_ADDRESS_LINE1}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierRegisteredAddress_Line1}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SUPPLIER_REGISTERED_ADDRESS_LINE2}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierRegisteredAddress_Line2}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.CITY}</DataTableCellV2>
            <DataTableCellV2>{props.formData.city}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.STATE_PROVINCE}</DataTableCellV2>
            <DataTableCellV2>{props.formData.state}</DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.POSTAL_CODE}</DataTableCellV2>
            <DataTableCellV2>{props.formData.postalCode}</DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.COUNTRY}</DataTableCellV2>
            <DataTableCellV2>
              {props.formData.country?.CountryName?.toLowerCase() !== 'other'
                ? props.formData.country?.CountryName ?? ''
                : `Other - ${props.formData.otherCountryName}`}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.PAYEE_NAME}</DataTableCellV2>
            <DataTableCellV2>{props.formData.payeeName}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>Payee Address Line1</DataTableCellV2>
            <DataTableCellV2>{props.formData.payeeAddress_Line1}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>Payee Address Line2</DataTableCellV2>
            <DataTableCellV2>{props.formData.payeeAddress_Line2}</DataTableCellV2>
          </DataTableRowV2>

          {isCountryChinaOrJapan(props.formData.billingCountry.CountryName) && (
            <LocalAddressData localData={props?.formData} />
          )}

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.PAYEE_CITY}</DataTableCellV2>
            <DataTableCellV2>{props.formData.payeeCity}</DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.PAYEE_STATEORPROVINCE}
            </DataTableCellV2>
            <DataTableCellV2>{props.formData.payeeState}</DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.PAYEE_POSTAL_CODE}</DataTableCellV2>
            <DataTableCellV2>{props.formData.payeePostalCode}</DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.PAYEE_COUNTRY}</DataTableCellV2>
            <DataTableCellV2>
              {props.formData.payeeCountry.CountryName?.toLowerCase() !== 'other'
                ? props.formData.payeeCountry?.CountryName ?? ''
                : `Other - ${props.formData.otherPayeeCountryName}`}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.COMPANY_FINANCE_DECISION}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.isKeyFinancialDecisionMaker}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SUPPLIER_CONTACT_PERSON}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierContactPerson}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SUPPLIER_EMAIL_ADDRESS}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierEmailAddress}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SUPPLIER_PHONE_NUMBER}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierPhoneNumber}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.SUPPLIER_FAX_NUMBER}</DataTableCellV2>
            <DataTableCellV2>
              {props.formData.supplierFaxNumber}
            </DataTableCellV2>
          </DataTableRowV2>
        </DataTableBodyV2>
      </DataTableV2>

      <AccentBar />
      <div className="new-line" />
      <Label>{LABELCONST.SUPPLIER_INFORMATION}</Label>
      <Label
        className="editInfo float-right"
        onClick={() => {
          editSupplierInfo(2);
        }}
      >
        Edit
        <IconEdit />
      </Label>
      <div className="new-line" />

      <DataTableV2 id="table-base-instance" striped>
        <DataTableHeadV2>
          <DataTableHeadCellV2 className="table-gap">Field</DataTableHeadCellV2>
          <DataTableHeadCellV2>Value</DataTableHeadCellV2>
        </DataTableHeadV2>
        <DataTableBodyV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.IS_MSME, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.IS_MSME}</DataTableCellV2>
            <DataTableCellV2>{props.formData.isMsme}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.PAN, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.PAN}</DataTableCellV2>
            <DataTableCellV2>{props.formData.panNo}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.SERVICE_TAX, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.SERVICE_TAX_NO}</DataTableCellV2>
            <DataTableCellV2>{props.formData.serviceTaxNo}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.ABN, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.ABN}</DataTableCellV2>
            <DataTableCellV2>{props.formData.abn}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.REGISTERED_STATE, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.REGISTERED_STATE}</DataTableCellV2>
            <DataTableCellV2>{props.formData.registeredState}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.REGISTRATION_NUMBER, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.REGISTERED_STATE_NO}</DataTableCellV2>
            <DataTableCellV2>{props.formData.registeredStateNo}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.UEN, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.UEN}</DataTableCellV2>
            <DataTableCellV2>{props.formData.uen}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.GST_NO}</DataTableCellV2>
            <DataTableCellV2>{props.formData.gstNo}</DataTableCellV2>
          </DataTableRowV2>
          {isBillingCountryAndCountryFrance(props.formData.billingCountry.CountryName, props.formData.country.CountryName) && (
            <>
              <DataTableRowV2>
                <DataTableCellV2>{LABELCONST.SIREN_NUMBER}</DataTableCellV2>
                <DataTableCellV2>{props.formData.sirenNumber}</DataTableCellV2>
              </DataTableRowV2>
              <DataTableRowV2>
                <DataTableCellV2>{LABELCONST.SIRET_NUMBER}</DataTableCellV2>
                <DataTableCellV2>{props.formData.siretNumber}</DataTableCellV2>
              </DataTableRowV2>
            </>
          )}
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.BUSINESS_REG_CERT_NO, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.BUSINESS_REG_CERT_NO}</DataTableCellV2>
            <DataTableCellV2>{props.formData.businessRegCertNo}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.TIN, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.TIN}</DataTableCellV2>
            <DataTableCellV2>{props.formData.tin}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.AUDIT_FIRM}</DataTableCellV2>
            <DataTableCellV2>{props.formData.isAuditFirm}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.PAYMENT_METHOD}</DataTableCellV2>
            <DataTableCellV2>{updatedPaymentMethod()}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.REMITTANCE_EMAIL_ADDRESS}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.remittanceEmailAddress}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.PAYMENT_TERMS}</DataTableCellV2>
            <DataTableCellV2>{props.formData.paymentTerms}</DataTableCellV2>
          </DataTableRowV2>
          {isPaymentMethodCPCOrBIP(props.formData?.paymentMethod?.toLowerCase()) && <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.SERVICE_ESTABLISHMENT}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.serviceEstablishment}
            </DataTableCellV2>
          </DataTableRowV2>}
          <DataTableRowV2 className={isTaxFieldVisible(stringConstants.NIF, props.formData.billingCountry.CountryName) ? '' : 'display-none'}>
            <DataTableCellV2>{LABELCONST.NIF}</DataTableCellV2>
            <DataTableCellV2>{props.formData.nif}</DataTableCellV2>
          </DataTableRowV2>
        </DataTableBodyV2>
      </DataTableV2>

      <AccentBar />
      <div className="new-line" />
      <Label>{LABELCONST.SUPPLIER_BANKING_INFORMATION}</Label>
      <Label
        className="editInfo float-right"
        onClick={() => {
          editSupplierInfo(3);
        }}
      >
        Edit
        <IconEdit />
      </Label>
      <div className="new-line" />

      <DataTableV2 id="table-base-instance" striped={true}>
        <DataTableHeadV2>
          <DataTableHeadCellV2 className="table-gap">Field</DataTableHeadCellV2>
          <DataTableHeadCellV2>Value</DataTableHeadCellV2>
        </DataTableHeadV2>
        <DataTableBodyV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.BANK_NAME}</DataTableCellV2>
            <DataTableCellV2>{props.formData.bankName}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.BIC}</DataTableCellV2>
            <DataTableCellV2>{props.formData.bic}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.BRANCH_NAME}</DataTableCellV2>
            <DataTableCellV2>{props.formData.branchName}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{isCountryPhilippenes(props.formData?.billingCountry?.CountryName) ? 'Personate ID / BRSTN' : LABELCONST.BRANCH_CODE}</DataTableCellV2>
            <DataTableCellV2>{props.formData.branchCode}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.ACCOUNT_NUMBER}</DataTableCellV2>
            <DataTableCellV2>{props.formData.accountNumber}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.ACCOUNT_TYPE}</DataTableCellV2>
            <DataTableCellV2>{props.formData.accountType}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.ABA}</DataTableCellV2>
            <DataTableCellV2>{props.formData.aba}</DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.INTERMEDIATE_BANK_NAME}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.intermediateBankName}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.INTERMEDIATE_BANK_BIC}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.intermediateBankBic}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.INTERMEDIATE_BANK_BRANCH_NAME}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.intermediateBankBranchName}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.INTERMEDIATE_BANK_BRANCH_CODE}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.intermediateBankBranchCode}
            </DataTableCellV2>
          </DataTableRowV2>

          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.INTERMEDIATE_BANK_ACCOUNT_NUMBER}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.intermediateBankAccountNumber}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.INTERMEDIATE_BANK_ABA}
            </DataTableCellV2>
            <DataTableCellV2>{props.formData.intermediateABA}</DataTableCellV2>
          </DataTableRowV2>
          {isCountryJapan(props.formData.billingCountry.CountryName) && (
            <DataTableRowV2>
              <DataTableCellV2>
                {LABELCONST.SUPPLIER_JAPAN_BANK_NAME}
              </DataTableCellV2>
              <DataTableCellV2>{props.formData.japanBankName}</DataTableCellV2>
            </DataTableRowV2>
          )}
          {isCountryJapan(props.formData.billingCountry.CountryName) && (
            <DataTableRowV2>
              <DataTableCellV2>
                {LABELCONST.SUPPLIER_JAPAN_BRANCH_NAME}
              </DataTableCellV2>
              <DataTableCellV2>{props.formData.japanBranchName}</DataTableCellV2>
            </DataTableRowV2>
          )}
          {isCountrySweden(props.formData.billingCountry.CountryName) && (
            <DataTableRowV2>
              <DataTableCellV2>
                {LABELCONST.BANK_GIRO_NUMBER}
              </DataTableCellV2>
              <DataTableCellV2>{props.formData.bankGiroNumber}</DataTableCellV2>
            </DataTableRowV2>
          )}
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.ATTACHED_FILES}</DataTableCellV2>
            <DataTableCellV2>
              <div className="new-line" />
              {props.uploadedDocs?.map((doc, key) => (
                <div key={key}>{doc.docName}</div>
              ))}
              {Object.entries(props.alreadyAttachedFiles)[0]?.[1]?.map((field, key) => (
                <div key={key}>{field.name}</div>
              ))}
              {Object.entries(props.files)[0]?.[1]?.map((field, key) => (
                <div key={key}>{field.name}</div>
              ))}
              <div className="new-line" />
            </DataTableCellV2>
          </DataTableRowV2>
        </DataTableBodyV2>
      </DataTableV2>
      <AccentBar />
      <div className="new-line" />
      <Label>{LABELCONST.AMERICAN_EXPRESS_CONTACT_INFORMATION}</Label>
      <Label
        className="editInfo float-right"
        onClick={() => {
          editSupplierInfo(4);
        }}
      >
        Edit
        <IconEdit />
      </Label>
      <div className="new-line" />
      <DataTableV2 id="table-base-instance" striped={true}>
        <DataTableHeadV2>
          <DataTableHeadCellV2 className="table-gap">Field</DataTableHeadCellV2>
          <DataTableHeadCellV2>Value</DataTableHeadCellV2>
        </DataTableHeadV2>
        <DataTableBodyV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.AMEX_CONTACT_NAME}</DataTableCellV2>
            <DataTableCellV2>{props.formData.amexContactName}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>{LABELCONST.AMEX_CONTACT_EMAIL}</DataTableCellV2>
            <DataTableCellV2>{props.formData.amexContactEmail}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.AMEX_CONTACT_TELEPHONE_NUMBER}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.amexContactNumber}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>
              {LABELCONST.AMEX_CONTACT_BUSINESS_UNIT}
            </DataTableCellV2>
            <DataTableCellV2>
              {props.formData.amexContactBusinessUnit}
            </DataTableCellV2>
          </DataTableRowV2>
        </DataTableBodyV2>
      </DataTableV2>
    </div>
  );
};

export default ReviewPage;
